import validate from "F:/webroot/diary.ilovearomagrace.com/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.0_@types+node@22.10.10_db0@0.2.1_ioredis@5.4.2_magicast@0.3.5_qy5utlq67x3zkyabdp7nzs3lje/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "F:/webroot/diary.ilovearomagrace.com/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}